module.exports = __webpack_public_path__ + "4e2702bb8e5678fb35e779a27796c5b1.jpg";